<template>
  <transition
  @enter="enter"
  @leave="leave"
  :css="false"
  appear>
    <ul class="users-list" v-if="users && !gameInProgress">
      <li v-for="user in users">
        <button class="button-player-select">
          {{user.first_name}}
        </button>
      </li>
    </ul>
  </transition>
</template>

<script>

  import {TweenLite} from 'gsap'

  export default {
    props: ['users', 'game-in-progress'],
    methods: {
      enter (el, done) {
        console.log('enter')
        TweenLite.from(el, 2, {
          autoAlpha: 0,
          onComplete: done
        })
      },
      leave (el, done) {
        TweenLite.to(el, 0.3, {
          autoAlpha: 0,
          onComplete: done
        })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/UsersList.vue